import { render, staticRenderFns } from "./RelevanceDialog.vue?vue&type=template&id=54305410&scoped=true&"
import script from "./RelevanceDialog.vue?vue&type=script&lang=js&"
export * from "./RelevanceDialog.vue?vue&type=script&lang=js&"
import style0 from "./RelevanceDialog.vue?vue&type=style&index=0&id=54305410&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54305410",
  null
  
)

export default component.exports